var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_167_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_248_",
    points: "12.26,23.62 9.29,20.65 10.44,19.5 12.26,21.32 15.56,18.02 16.71,19.17  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_245_",
    d: "M18.69,11.6H7.31V0.22h11.38V11.6z M8.94,9.97h8.12V1.85H8.94V9.97z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_165_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_242_",
    d: "M18.69,26.22H7.31V14.85h11.38V26.22z M8.94,24.6h8.12v-8.12H8.94V24.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGroup);
export default __webpack_public_path__ + "static/media/CheckboxGroup.e1f1527e9e581d1910fe57cab26eb930.svg";
export { ForwardRef as ReactComponent };